import DatePickerField from '@app/components/Layout/Shares/FormHelpers/DatimePickerField';
import RenderTextField from '@app/components/Layout/Shares/FormHelpers/TextField';
import { swal } from '@app/utils/alert';
import moment from 'moment';
import { useState } from 'react';
import validate from './validate';
import { ScField, ScModalFinalForm } from '@app/components/Base/ScFinalForm';

const CopyMenuModalImport = ({ isShow, onClose, proFood, onImportMenu }) => {
    const [fileName, setFileName] = useState('');
    const [objMenu, setObjMenu] = useState({});

    const onSaveImport = (data) => {
        const dataPost = {
            ...data,
            m_datefounded: moment(data.m_datefounded).startOf('day').unix(),
        };

        onImportMenu?.({ dataPost, file: objMenu });
    };

    const csvFileToArray = (jsonCsv) => {
        try {
            const parseJson = jsonCsv ? JSON.parse(jsonCsv) : [];
            const parseObj = Object.assign({}, ...parseJson);
            const _objMenu = {
                m_quantity: parseObj?.Siso,
                m_price: parseObj?.Tiendinhmuc,
                m_pricebefore: parseObj?.Tienmottre,
                m_breakfast: parseObj?.Buasang,
                m_lunch: parseObj?.Buatrua,
                m_dinner: parseObj?.Buaxe,
                m_snack: parseObj?.Buaphu,
                listSchoolFood: parseObj?.ChiTietThucDons?.map((o) => {
                    const food = proFood?.find(
                        (x) => x.f_nameabbreviation === o.Tentat,
                    );
                    return {
                        f_id: food?.f_id,
                        fc_id: food?.fc_id,
                        f_name: food?.f_name,
                        f_group: food?.f_group,
                        // f_disposalrate: food?.f_disposalrate,
                        f_disposalrate: o?.Hesothaibo,
                        sf_price: o?.Giatien,
                        msf_sortorder: o?.Thutusapxep,
                        msf_quantitybefore: o?.Soluonggam,
                        msf_totalquantitybefore: o?.Soluongthucmua,
                        msf_pricebefore: o?.Giatien,
                        msf_pricefoodbefore: o?.Tienmotthucpham,
                        msf_meal: o?.Buaan,
                        cu_code: o?.Tendonvitinh,
                    };
                }),
                listService: parseObj?.DichVuThucDons?.map((o) => ({
                    ms_name: o?.Tenloaihinhdichvu,
                    ms_price: o?.Giatienmottre,
                })),
            };

            setObjMenu(_objMenu);
        } catch {
            swal('warning', 'Tập tin đính kèm không hợp lệ !');
        }
    };

    const handleOnChange = (e) => {
        const file = e.target.files[0];

        setFileName(file?.name);

        if (file) {
            const reader = new FileReader();

            reader.onload = function (event) {
                const text = event.target.result;
                csvFileToArray(text);
            };

            reader.readAsText(file);
        }
    };

    return (
        <ScModalFinalForm
            open={isShow}
            title="Thêm thực đơn từ file CSV"
            onSubmit={onSaveImport}
            validate={validate}
            onClose={onClose}
        >
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <ScField
                                    name="m_datefounded"
                                    component={DatePickerField}
                                    type="text"
                                    className="form-control"
                                    label="Ngày lập"
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <ScField
                                    name="m_code"
                                    component={RenderTextField}
                                    type="text"
                                    className="form-control"
                                    label="Mã thực đơn"
                                />
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="form-group">
                                <label>
                                    <h6 className="panel-title">
                                        Tập tin đính kèm
                                    </h6>
                                </label>
                                <div>
                                    <div className="file-input file-input-new">
                                        <div className="input-group file-caption-main">
                                            <div
                                                className="form-control file-caption  kv-fileinput-caption"
                                                style={{ zIndex: 0 }}
                                            >
                                                <div
                                                    className="file-caption-name"
                                                    title="Chọn tập tin"
                                                >
                                                    <i className="glyphicon glyphicon-file kv-caption-icon" />
                                                    {fileName || 'Chọn tập tin'}
                                                </div>
                                            </div>

                                            <div className="input-group-btn">
                                                <div className="btn btn-primary btn-file">
                                                    <i className="icon-file-plus" />
                                                    <span className="hidden-xs">
                                                        Chọn tập tin
                                                    </span>
                                                    <input
                                                        type="file"
                                                        className="file-input"
                                                        id="csvFileInput"
                                                        accept=".csv"
                                                        onChange={
                                                            handleOnChange
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ScModalFinalForm>
    );
};

export default CopyMenuModalImport;
